module.exports = __webpack_public_path__ + "img/userPhRes_b.968de58a.png";